import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';
import { append_active_organization_id } from "@/utils/organization_profile";


export default {
  mounted() {
    this.token_exists = get_token();
    this.fetch_master_Portals()
    this.user_details=get_user_details();


  const modal = document.getElementById("select_sub_portals_modal");
        modal.addEventListener("shown.bs.modal", () => {
          this.fetch_all_portals();
          this.filterPortals();
        });
  },


watch: {
    '$route.params.portal_id': {
      handler: 'fetch_master_Portals',
      immediate: true
    },
    all_portals: {
        handler: 'filterPortals',
        immediate: true
      }
  },

  data() {
    return ({
    mater_portals:[],
    token_exists: false,
    master_portals:[],
    portal_id:'',
    filteredPortals : [],
    all_portals: [],
    selectedPortals: [],
    edit_is_master:true
    })
  },

  methods:
  {
    getToken() {
        return get_token();
      },

    fetch_master_Portals() {
        this.isLoading = true;
        this.portal_id = this.$route.params.portal_id
        const request_data = {
            portal_id: this.$route.params.portal_id
          };
        $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_master_portal_api/`,
        method: 'POST',
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (data) => {
            if (data.status === 'success') {
                this.master_portals = data.master_portals;
              }
        },
        complete: () => {
            this.isLoading = false;
        }
        });
    },

     editPortal() {
        const portal_id = this.$route.params.portal_id;

          const payload = {

            portal_id: portal_id,
            update_values:{
              name: this.edit_portal,
              description: this.edit_description||'null',

            },
            is_master: this.edit_is_master,
            portal_ids:this.selectedPortals || [],
          }
    
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_portal_api/`,
    
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            data: JSON.stringify(payload),
            success: (response) => {
              const status = response.status;
              Swal.fire({
                icon: 'success',
                title: 'Updated',
                text: 'Portal has been updated.',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              })
              if (status === "success") {
                $('#select_sub_portals_modal').modal('hide');
                this.fetch_master_Portals();
              }
            }
          });
        },
        filterPortals() {
            this.portal_master_id = this.$route.params.portal_id;

            if (!this.all_portals || this.all_portals.length === 0) {
              this.filteredPortals = [];
              return;
            }

            if (!this.master_portals || this.master_portals.length === 0) {
              this.filteredPortals = this.all_portals.filter(
                portal => portal.id !== this.portal_id && portal.id !== this.portal_master_id
              );
              return;
            }

            const masterPortalIds = new Set(this.master_portals.map(mp => mp.id));

            this.filteredPortals = this.all_portals.filter(portal => {
              if (!portal.id) {
                return true;
              }
              return (
                !masterPortalIds.has(portal.id) &&
                portal.id !== this.portal_id &&
                portal.id !== this.portal_master_id
              );
            });
          },

        fetch_all_portals() {
            const portal_id = parseInt(this.$route.params.portal_id,10);
            this.isLoading = true;
            return new Promise((resolve) => {
              $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
                method: 'POST',
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                data: JSON.stringify(append_active_organization_id({})),
                success: (data) => {
                  this.all_portals = data.portals.filter(portal => {
                    return portal.id !== portal_id;
                  });
                  this.filterPortals();
        resolve();
      },
      error: () => {
        resolve();
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  });
},
          toggleSelectAll() {
            if (this.areAllSelected) {
              this.selectedPortals = [];
            } else {
              this.selectedPortals = this.availablePortals.map(portal => portal.id);
            }
          },
          toggleSelectAllSubPortals() {
            const filteredIds = (this.filteredPortals || []).map(portal => portal.id);

            if (this.areAllSubPortalsSelected) {
                this.selectedPortals = this.selectedPortals.filter(id => !filteredIds.includes(id));
            } else {
                this.selectedPortals = [...new Set([...this.selectedPortals, ...filteredIds])];
            }

        },
        confirmSelectedPortals() {
            $('#select_sub_portals_modal').modal('hide');
          },



  }
}
